import { render, staticRenderFns } from "./LoadEmbed.vue?vue&type=template&id=0bbe5928&scoped=true&"
import script from "./LoadEmbed.vue?vue&type=script&lang=js&"
export * from "./LoadEmbed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bbe5928",
  null
  
)

export default component.exports